export enum Environment {
  local = 'localhost',
  DEV = 'development',
  QA = 'qa',
  STAGING = 'staging',
  PROD = 'production',
}
